export function QRFCParam() {
  this.fParameter = null;
  this.fValue = null;
}
